export const validateTwoDecimals = value => {
  const regex = /^\d+(\.\d{1,2})?$/
  return regex.test(value)
}

export const isValidPercent = value => {
  return validateTwoDecimals(value) && value >= 0 && value <= 100
}

export const isValidBonusPerConversion = value => {
  return validateTwoDecimals(value) && value >= 0 && value <= 50
}
